import { render, staticRenderFns } from "./model_lists.vue?vue&type=template&id=5223ed08&scoped=true"
import script from "./model_lists.vue?vue&type=script&lang=ts"
export * from "./model_lists.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5223ed08",
  null
  
)

export default component.exports